import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reports-ims',
  templateUrl: './reports-ims.component.html',
  styleUrls: ['./reports-ims.component.css']
})
export class ReportsImsComponent implements OnInit {
  url: string = '';
  urlSafe: SafeResourceUrl;
  constructor(public sanitizer: DomSanitizer,  private router: Router,
    private auten:AuthenticationService) { }

  ngOnInit(): void {
    var CompanyID = this.auten.currentUserValue.companyIdWh
    var ClientAccNum =this.auten.currentUserValue.customerId
    var UserName = this.auten.currentUserValue.name
    var UserID = this.auten.currentUserValue.id
    var AppTheme = '';
    var ul = '';

    if (ClientAccNum == '') {
      ul +=
        environment.apiComplement +
        '/LoginWerehouse.aspx?CompanyID=' +
        CompanyID +
        '&UserName=' +
        UserName +
        '&UserID=' +
        UserID +
        '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css';
    } else {
      ul +=
        environment.apiComplement +
        '/LoginWerehouse.aspx?CompanyID=' +
        CompanyID +
        '&UserName=' +
        UserName +
        '&UserID=' +
        UserID +
        '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css&ClientAccNum=' +
        ClientAccNum;
    }

  //  this.url = ul;
    //  console.log(this.url);
      //this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

  
      setTimeout(() => {
       this.url = `${environment.apiComplement}/views/partner/reports?`+'CompanyID=' +
       CompanyID +
       '&UserName=' +
       UserName +
       '&UserID=' +
       UserID +
       '&AppTheme=https://cdn.3plfreightsoftware.com/cdn/css/Start/jqueryuimaster.min.css&ClientAccNum=' +
       ClientAccNum;
       // var j=parent.location.href="javascript:window.location.href='"+`${environment.apiComplement}/views/partner/reports?`+"c=' + document.cookie"
//this.url=j;
        /** spinner ends after 5 seconds */
        this.Rediret();
      }, 1500);
  }
  Rediret() {
    var acceso = this.url;
	window.open(acceso, '_blank', 'width=800, height=600,toolbar=0');
	this.router.navigate(['/home']);
    //$('#viewpp').attr('src', acceso);
    //$('#viewpp').fadeIn();
  }

}
